import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getDiariesListData } from "../../../containers/Diaries/actions";
import LeftPanel from "./leftPanel";
import RightPanel from "./RightPanel";
import { isMobile } from '../../../common/util';
import { PAGE_SIZE } from '../../WorkkardDetail/constants';
import { selectSessionContextOidc } from '@/containers/AdminPanel/features/users/usersSelectors';
import { DEFAULT_PRIORITY } from '@/common/constants';

const DiaryDetail = () => {
    const dispatch = useDispatch();
    const [showMobileDetail, setShowMobileDetail] = useState(false);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userId = sessionContext?.userView?.id;

    useEffect(() => {
        dispatch(getDiariesListData({
            scope       : "personal",
            todoOwners  : userId,
            status      : 1,
            page_size   : PAGE_SIZE,
            page_no     : 1,
            priority    : DEFAULT_PRIORITY,
            isMobileView: isMobile(),
        }));
    }, [dispatch]);

    return (
        <div className="detailPage">
            <LeftPanel setMobileView={setShowMobileDetail} />
            <RightPanel
                showMobileView={showMobileDetail}
                setshowMobileView={setShowMobileDetail}
            />
        </div>
    );
};

export default DiaryDetail;